import { ToolState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
  tools: (state: ToolState) => state.tools,
  oneTool: (state: ToolState) => (toolId: number) => {
    const filtered = state.tools.filter((tool) => tool.id === toolId);
    if (filtered.length > 0) {
      return { ...filtered[0] };
    }
  },
};

const { read } = getStoreAccessors<ToolState, State>('');

export const readTools = read(getters.tools);
export const readOneTool = read(getters.oneTool);
